module.exports = __webpack_public_path__ + "static/media/emojibg.eccdc57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emojibg.png
// module id = 17
// module chunks = 0